function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ChatSidebarTemplate = require('./chat-sidebar.template');
var SaitoProfile = require('./../../../../lib/saito/ui/saito-profile/saito-profile');
var ChatUserMenu = require('../overlays/chat-user-menu');
var SaitoUser = require('./../../../../lib/saito/ui/saito-user/saito-user');
var ChatSidebar = /*#__PURE__*/function () {
  function ChatSidebar(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.saito-sidebar.right';
    _classCallCheck(this, ChatSidebar);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.profile = new SaitoProfile(app, mod, '.chat-sidebar');
    this.profile.tab_container = '.saito-modal-content';
    app.connection.on('chat-manager-opens-group', function () {
      var _this$group;
      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (group && group.id !== (_this === null || _this === void 0 || (_this$group = _this.group) === null || _this$group === void 0 ? void 0 : _this$group.id)) {
        _this.render(group);
      }
    });
    app.connection.on('chat-popup-remove-request', function () {
      var _this$group2;
      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if ((group === null || group === void 0 ? void 0 : group.id) == (_this === null || _this === void 0 || (_this$group2 = _this.group) === null || _this$group2 === void 0 ? void 0 : _this$group2.id)) {
        _this.remove();
      }
    });
  }
  return _createClass(ChatSidebar, [{
    key: "remove",
    value: function remove() {
      if (document.getElementById('chat-sidebar')) {
        document.getElementById('chat-sidebar').remove();
      }
      this.group = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$mod$communityGr;
      var chat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!chat) {
        return;
      }
      this.group = chat;
      if (document.getElementById('chat-sidebar')) {
        this.app.browser.replaceElementById(ChatSidebarTemplate(this.app, this.mod), 'chat-sidebar');
      } else {
        this.app.browser.addElementToSelector(ChatSidebarTemplate(this.app, this.mod), this.container);
      }
      if (!document.querySelector('.chat-sidebar .saito-modal-content')) {
        this.app.browser.addElementToSelector("<div class=\"saito-modal-content hide-scrollbar\"></div>", '.chat-sidebar');
      }
      var groupKey = chat.id;
      var dm = false;
      this.profile.mask_key = true;
      if (chat.member_ids) {
        // Multiparty Group
        this.profile.reset(groupKey, 'members', ['members']);
        var _iterator = _createForOfIteratorHelper(chat.members),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var m = _step.value;
            var name = m;
            if (m == this.app.keychain.returnIdentifierByPublicKey(m, true)) {
              name = '';
            }

            // Could add a fourth element so admins can delete people...

            var user = new SaitoUser(this.app, this.mod, '.chat-sidebar .saito-modal-content', m, name);
            user.extra_classes = 'saito-add-user-menu saito-contact';
            if (chat.member_ids[m] == 'admin') {
              user.icon = "<i class=\"saito-overlaid-icon fa-solid fa-key\"></i>";
            }
            this.profile.menu.members.push(user);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (chat.id == ((_this$mod$communityGr = this.mod.communityGroup) === null || _this$mod$communityGr === void 0 ? void 0 : _this$mod$communityGr.id) || chat.name == this.mod.communityGroupName || chat.members.length !== 2) {
        // Community Chat
        // If the peerservices haven't come up, we won't have a communityGroup obj yet....
        this.profile.reset(groupKey, 'active', ['active']);
        this.profile.name = chat.name;
        this.profile.mask_key = true;

        //Scan stored transactions for list of people active in community
        var active_users = [];
        for (var i = chat.txs.length - 1; i >= 0; i--) {
          var key = chat.txs[i].from;
          if (Array.isArray(key)) {
            var _iterator2 = _createForOfIteratorHelper(key),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var k = _step2.value;
                if (!active_users.includes(k)) {
                  active_users.push(k);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          } else {
            if (!active_users.includes(key)) {
              active_users.push(key);
            }
          }
        }

        //Build data structure
        for (var _i = 0, _active_users = active_users; _i < _active_users.length; _i++) {
          var _m = _active_users[_i];
          var _name = _m;
          if (_m == this.app.keychain.returnIdentifierByPublicKey(_m, true)) {
            _name = '';
          }
          var _user = new SaitoUser(this.app, this.mod, '.chat-sidebar .saito-modal-content', _m, _name);
          _user.extra_classes = 'saito-add-user-menu saito-contact';
          this.profile.menu.active.push(_user);
        }
      } else {
        // 1-1 chat
        dm = true;
        var _iterator3 = _createForOfIteratorHelper(chat.members),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var member = _step3.value;
            if (member !== this.mod.publicKey) {
              groupKey = member;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        this.profile.reset(groupKey);
      }
      this.profile.description = chat.description;
      this.profile.render();
      this.app.browser.addElementToSelector("<div id=\"chat-group-edit\" class=\"saito-modal-menu-option\"><i class=\"fa-solid fa-users-gear\"></i><div>Manage Chat</div></div>", '.chat-sidebar .saito-profile-controls');
      if (dm) {
        this.addUserMenu(groupKey);
      }
      this.attachEvents(chat);
    }
  }, {
    key: "addUserMenu",
    value: function addUserMenu(user_publickey) {
      var _this2 = this;
      var availableMods = this.app.modules.returnModulesRespondingTo('user-menu', {
        publicKey: user_publickey
      });
      var index = 0;
      var _iterator4 = _createForOfIteratorHelper(availableMods),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var am = _step4.value;
          if (am.returnName() !== this.mod.returnName()) {
            var item = am.respondTo('user-menu', {
              publicKey: user_publickey
            });
            if (item instanceof Array) {
              item.forEach(function (j) {
                _this2.addMenuItem(j, "user_menu_item_".concat(index++), user_publickey);
              });
            } else if (item != null) {
              this.addMenuItem(item, "user_menu_item_".concat(index++), user_publickey);
            }
          }
        }

        //This is not in a respondTo????
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.addMenuItem({
        icon: 'fas fa-money-check-dollar',
        text: 'Send Crypto',
        callback: function callback(app, publicKey) {
          app.connection.emit('saito-crypto-withdraw-render-request', {
            address: publicKey,
            ticker: 'SAITO'
          });
        }
      }, "user_menu_item_".concat(index++), user_publickey);
    }
  }, {
    key: "addMenuItem",
    value: function addMenuItem(item, id, publicKey) {
      var _this3 = this;
      this.app.browser.addElementToSelector("<div id=\"".concat(id, "\" class=\"saito-modal-menu-option\"><i class=\"").concat(item.icon, "\"></i><div>").concat(item.text, "</div></div>"), '.saito-profile-controls');
      var menu_option = document.getElementById(id);
      if (menu_option) {
        menu_option.onclick = function (e) {
          item.callback(_this3.app, publicKey);
        };
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(chat) {
      var _this4 = this;
      if (document.getElementById('chat-group-edit')) {
        document.getElementById('chat-group-edit').onclick = function (e) {
          var chatMenu = new ChatUserMenu(_this4.app, _this4.mod, chat);
          chatMenu.render();
        };
      }

      // Add .remove_user functionality
      Array.from(document.querySelectorAll('.remove_user')).forEach(function (member) {
        member.onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            var person, i;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  person = e.currentTarget.dataset.id;
                  if (!person) {
                    _context.n = 5;
                    break;
                  }
                  _context.n = 1;
                  return _this4.mod.sendRemoveMemberTransaction(chat, person);
                case 1:
                  i = 0;
                case 2:
                  if (!(i < chat.members.length)) {
                    _context.n = 4;
                    break;
                  }
                  if (!(chat.members[i] == person)) {
                    _context.n = 3;
                    break;
                  }
                  chat.members.splice(i, 1);
                  return _context.a(3, 4);
                case 3:
                  i++;
                  _context.n = 2;
                  break;
                case 4:
                  chat.member_ids[person] = -1;
                case 5:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      });
    }
  }]);
}();
module.exports = ChatSidebar;